import { z } from 'zod/v4';

export const CrmPipelineStepContract = z.object({
    id: z.number(),
    pipelineId: z.number(),
    name: z.string(),
    order: z.number(),
    color: z.string(),
    status: z.number(),
});

export const CrmPipelineSettingContract = z.object({
    name: z.string(),
    // CRM sends whatever a setting holds (null for an unassigned `responsible`,
    // nested payloads for newer settings). Nothing reads the value — the editor
    // stores `settings` verbatim and the builder posts it back — so the contract
    // must not gate on its type. Same reason the SSR chat-bot schema uses `z.any()`.
    value: z.unknown(),
});

export const CrmPipelineContract = z.object({
    id: z.number(),
    status: z.number(),
    name: z.string(),
    order: z.number(),
    userId: z.number(),
    settings: z.array(CrmPipelineSettingContract),
    steps: z.array(CrmPipelineStepContract),
});

export const CrmPipelineCollectionResponseSchema = z.object({
    data: z.array(CrmPipelineContract),
});

export type CrmPipeline = z.infer<typeof CrmPipelineContract>;
export type CrmPipelineStep = z.infer<typeof CrmPipelineStepContract>;
export type CrmPipelineSetting = z.infer<typeof CrmPipelineSettingContract>;
